<style scoped>
.ischangec {
  background: rgba(242, 247, 255, 0.8);
  color: #1E40AF;
}
.selectColor {
  color: #1E40AF !important;
}
.tree_sinle_l {
  font-size: 16px;
  max-width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #5c5c5c;
  /* color: #0058ff; */
}
::v-deep .tree_case:hover {
  background: #f2f7ff;
}
.tree_case {
  overflow-y: auto; /* 添加滚动条 */
  max-height: 100%;
}
.tree_case::-webkit-scrollbar {
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.tree_sinle {
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
}
.tree_sinle_a {
  display: flex;
  align-items: center;
}
.tree_sinle_l {
  font-size: 16px;
  max-width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #5c5c5c;
  /* color: #0058ff; */
}
.tree_sinle_icon {
  width: 18px;
  height: 18px;
  margin-right: 12px;
}
</style>

<template>
  <div class="tree_case">
    <el-tree
        ref="tree"
        :node-key="treeKey"
        :data="departmentList"
        :default-expand-all="isExpand"
        :expand-on-click-node="false"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <div class="tree_sinle">
          <div class="tree_sinle_a">
            <img
                src="@/assets/structure/plan.png"
                class="tree_sinle_icon"
            />
            <div
                :class="[
                'tree_sinle_l',
                ischangec == node.data.id ? 'selectColor' : '',
              ]"
            >
              {{ node.label }}
            </div>
          </div>
        </div>
      </span>
    </el-tree>
  </div>
</template>

<script>
import {queryDeptmentList} from "@/api/server/deptment";

export default {
  components: {
  },
  props: {
    filterText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      treeKey: "0",
      ischangec: '',
      defaultProps: {
        children: "subDepartment",
        label: "name",
      },
      isExpand: true, //是否默认展开全部节点
      departmentList: [],
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {
    queryDeptmentList().then(response => {
      let {code,data} = response;
      if(code == 200){
        this.departmentList = this.convertToNestedStructure(data);
        this.handleNodeClick(data[0])
      }
    });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data?.name?.indexOf(value) !== -1;
    },
    convertToNestedStructure(arr) {
      // 创建一个映射，用于快速查找具有特定id的对象
      const idMap = new Map(arr.map((item) => [item.id, item]));

      // 创建一个新数组来存储转换后的嵌套结构
      const nestedArr = [];

      // 遍历原始数组
      arr.forEach((item) => {
        // 如果该项有父元素，则将其添加到父元素的subDepartment数组中
        if (item.parent) {
          const parent = idMap.get(item.parent);
          if (parent) {
            if (!parent.subDepartment) {
              parent.subDepartment = [];
            }
            item.parentDepament = parent.name;
            parent.subDepartment.push(item);
          }
        } else {
          // 如果没有父元素，则添加到新数组的根级别
          nestedArr.push(item);
        }
      });

      // 返回转换后的嵌套数组
      return nestedArr;
    },
    handleNodeClick(data){
      this.ischangec = data?.id;
      const isParentMenu = (this.departmentList[0]?.id == data?.id);
      this.$emit('handleNodeClick',isParentMenu?{}:data);
    }
  }
}
</script>
